<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iiW2aa/tc-custom/9781439676233.jpg?1737196545544" alt="This image is the cover for the book Growing Up in Fairfield, California"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Growing Up in Fairfield, California
      </h1>
      <p class="bookDescription body article font2">
        <p>A magic nostalgia ride awaits.<br/><br/><br/><br/>Life in Fairfield in the decades after World War II was an unparalleled experience. From cruising down Texas Street on weekends to catching a carnival in the Wonder World parking lot, fond memories of long-lost times haven't been forgotten. People flocked to vintage eateries like Joe's Buffet and Smorga Bob's, and played on the rocket ship slide at Allan Witt Park. Roller Rinks like the M&amp;M Skateway hosted not just skaters, but dances featuring Fats Domino and Roy Orbison. Commuters hopped aboard the FART bus to save on gas, and frequenting Dave's Giant Hamburgers was a rite of passage.<br/><br/><br/><br/>Longtime Daily Republic journalist and accidental historian Tony Wade takes a deep dive into the Fairfield of yesteryear.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Wade
      </h2>
      
      <p class="authorDescription body article">Tony Wade came to Fairfield in 1976 when he was twelve and never left. He attended Grange Intermediate, Armijo High School and Solano Community College. In 2006, Wade began writing columns for the local newspaper, the Daily Republic. In 2011, he became an amateur historian when he began the "Back in the Day" columns for the Daily Republic. He is the elder brother of longtime Daily Republic columnist Kelvin Wade and lives in Fairfield with his wife, Beth, and their Chiweenie, Chunky Tiberius.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?eecb1722